/* p107 (Oct 3, 2026) Infused Lights small UX helpers.
   2) Header: marks the top menu item for the section you are in (aria-current + class il-current).
   1) Collection pages on phones: long collection descriptions are folded to a short preview with a
      "Read more" button, so products show up sooner. Nothing is removed; one tap shows the full text. */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    if (!window.matchMedia('(max-width:767px)').matches) return;
    var p = document.querySelector('.cat_des_ntt4 .il-col-panel');
    if (!p || p.getAttribute('data-il-fold')) return;
    if (p.scrollHeight < 420) return;
    p.setAttribute('data-il-fold', '1');
    p.classList.add('il-fold');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'il-fold-btn';
    b.setAttribute('aria-expanded', 'false');
    b.textContent = 'Read more';
    p.insertAdjacentElement('afterend', b);
    b.addEventListener('click', function () {
      var open = p.classList.toggle('il-fold-open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.textContent = open ? 'Show less' : 'Read more';
      if (!open) p.scrollIntoView({ block: 'nearest' });
    });
  });
})();

(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var path = location.pathname.replace(/\/+$/, '') || '/';
    var links = [].slice.call(document.querySelectorAll('#nt_menu_canvas .nt_menu > li > a'));
    if (!links.length) return;
    function find(fn) { for (var i = 0; i < links.length; i++) { if (fn(links[i].getAttribute('href') || '')) return links[i]; } return null; }
    var hit = find(function (h) { return h === path; });
    if (!hit) {
      var key = null;
      if (/^\/pages\/(character-|map-|starseed-|watch-the-trailer|worlds-and-maps|the-starseed-chronicles)/.test(path) || path === '/pages/iris') key = '/pages/the-starseed-chronicles';
      else if (/^\/(collections|products)(\/|$)/.test(path)) key = '/collections/all';
      else if (/^\/(blogs\/|pages\/(free-light-library|angel-numbers-index|life-path-number|astrology-star-map|prayer-request|about-us))/.test(path)) key = '/pages/free-light-library';
      if (key) hit = find(function (h) { return h === key; });
    }
    if (hit) { hit.classList.add('il-current'); hit.setAttribute('aria-current', hit.getAttribute('href') === path ? 'page' : 'true'); }
  });
})();

/* p107 (Oct 3, 2026): accessible names for icon-only controls. Screen readers announced
   these as "link" or "button" with no label. Only adds aria-label where none exists. */
(function () {
  function label(el, text) { if (el && text && !el.getAttribute('aria-label') && !(el.innerText || '').trim()) el.setAttribute('aria-label', text); }
  function run(root) {
    root = root || document;
    root.querySelectorAll('.push-menu-btn').forEach(function (a) { label(a, 'Open menu'); });
    root.querySelectorAll('a.icon_search').forEach(function (a) { label(a, 'Search'); });
    root.querySelectorAll('a[href^="mailto:"]').forEach(function (a) { label(a, 'Email ' + a.getAttribute('href').slice(7).split('?')[0]); });
    root.querySelectorAll('.search_header__submit, .js_btn_search').forEach(function (b) { label(b, 'Search'); });
    root.querySelectorAll('input[name="q"]').forEach(function (i) { if (!i.getAttribute('aria-label') && !(i.id && document.querySelector('label[for="' + i.id + '"]'))) i.setAttribute('aria-label', 'Search the site'); });
    root.querySelectorAll('input[type="email"]').forEach(function (i) { if (!i.getAttribute('aria-label') && !(i.id && document.querySelector('label[for="' + i.id + '"]')) && !i.closest('label')) i.setAttribute('aria-label', 'Email address'); });
    var share = { facebook: 'Share on Facebook', twitter: 'Share on X', email: 'Share by email', pinterest: 'Pin on Pinterest', tumblr: 'Share on Tumblr', telegram: 'Share on Telegram' };
    root.querySelectorAll('a.ttip_nt').forEach(function (a) { for (var k in share) if (a.classList.contains(k)) label(a, share[k]); });
    var per = { view_12: 'Show 1 per row', view_6: 'Show 2 per row', view_4: 'Show 3 per row', view_3: 'Show 4 per row', view_15: 'Show 5 per row', view_2: 'Show 6 per row', view_list: 'Show as list' };
    root.querySelectorAll('a.cat_view_page').forEach(function (a) { for (var k in per) if (a.classList.contains(k)) { label(a, per[k]); break; } });
    /* image links in product and article cards: borrow the title of the matching text link */
    root.querySelectorAll('a[href]').forEach(function (a) {
      if (a.getAttribute('aria-label') || (a.innerText || '').trim()) return;
      if (a.querySelector('img[alt]:not([alt=""])')) return;
      var href = a.getAttribute('href'); if (!href || href === '#') return;
      var box = a.parentElement, hops = 0, txt = '';
      while (box && hops < 5 && !txt) {
        box.querySelectorAll('a[href]').forEach(function (b) { if (!txt && b !== a && b.getAttribute('href') === href) txt = (b.innerText || '').trim(); });
        box = box.parentElement; hops++;
      }
      if (txt) { a.setAttribute('aria-label', txt.slice(0, 120)); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  window.addEventListener('load', function () { run(); setTimeout(run, 2500); });
})();

/* p107 (Oct 3, 2026): the header search box is narrower on laptops and its placeholder was cut
   off mid word ("Search Angel Numbers, Li"). Keep the full text where it fits, otherwise use the
   longest shorter version that fits. Full text stays available as the title tooltip. */
(function () {
  function fit() {
    document.querySelectorAll('input.search_header__input').forEach(function (i) {
      if (!i.dataset.ilPh) i.dataset.ilPh = i.getAttribute('placeholder') || '';
      var full = i.dataset.ilPh; if (!full || !i.clientWidth) return;
      var s = getComputedStyle(i), c = fit.c || (fit.c = document.createElement('canvas').getContext('2d'));
      c.font = s.fontStyle + ' ' + s.fontWeight + ' ' + s.fontSize + ' ' + s.fontFamily;
      var room = i.clientWidth - parseFloat(s.paddingLeft) - parseFloat(s.paddingRight) - 4;
      var opts = [full, 'Search angel numbers, guides', 'Search the site', 'Search'];
      for (var k = 0; k < opts.length; k++) { if (c.measureText(opts[k]).width <= room || k === opts.length - 1) { i.setAttribute('placeholder', opts[k]); break; } }
      if (!i.title) i.title = full;
    });
  }
  window.addEventListener('load', function () { fit(); setTimeout(fit, 1500); });
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 200); });
})();

/* p107 (Oct 3, 2026): "Skip to content" scrolled but left keyboard focus in the header, so the
   next Tab went back to the menu. Move focus to the main content. */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a.skip-link[href^="#"]'); if (!a) return;
  var t = document.getElementById(a.getAttribute('href').slice(1)); if (!t) return;
  if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
  t.focus({ preventScroll: false });
});

/* p107 (Oct 3, 2026): long pages (characters hub, Light Library posts) had no quick way back up.
   Add a small "Back to top" text link next to the footer copyright line. */
(function () {
  function add() {
    if (document.querySelector('.il-backtop')) return;
    var c = Array.prototype.find.call(document.querySelectorAll('footer .col_1, #nt_footer .col_1'), function (el) { return /\u00a9/.test(el.textContent); });
    if (!c) return;
    var a = document.createElement('a'); a.href = '#'; a.className = 'il-backtop'; a.textContent = 'Back to top \u2191';
    a.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); var h = document.querySelector('a.skip-link, header a'); if (h) h.focus({ preventScroll: true }); });
    c.appendChild(document.createTextNode(' ')); c.appendChild(a);
  }
  if (document.readyState !== 'loading') add(); else document.addEventListener('DOMContentLoaded', add);
})();
